import React, { FunctionComponent, useEffect, useState } from 'react';
import { IWidgetKpiMeetingTabParams } from './types';
import { Kpi } from '../../../../MeetingDashboardPage/Kpi';
import { useDispatch } from 'react-redux';
import { IMeeting } from '../../../../../../app/resource/meeting/meeting.types';
import { fetchKpi } from '../../../../../../app/page/page-storage/kpi/kpi.actions';
import { fetchMeetingsSimple } from '../../../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { useSelect } from '../../../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';

export const WidgetKpiMeetingTab: FunctionComponent<IWidgetKpiMeetingTabParams> = () => {
  const dispatch = useDispatch();
  const meetings = useSelect(meetingSimpleSelectors.selectResourceList);
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);

  const [meetingId, setMeetingId] = useState<IMeeting['id'] | undefined>(undefined);

  useEffect(() => {
    dispatch(fetchMeetingsSimple());
  }, [dispatch]);

  useEffect(() => {
    if (meetingId) {
      dispatch(fetchKpi(meetingId));
    }
  }, [dispatch, meetingId]);

  useEffect(() => {
    if (meetingId === undefined && meetings.length > 0) {
      setMeetingId(meetings[0].id);
    }
  }, [meetingId, meetings, setMeetingId]);

  if (meetings.length === 0) {
    return null;
  }

  return (
    <div className="col-12 mb-3">
      <Kpi meetingId={meetingId ?? meetings[0].id} changeMeetingId={setMeetingId} userId={loggedUserId ?? undefined} />
    </div>
  );
};
